module.exports = __webpack_public_path__ + "static/media/jobImg5.8d871269.jpg";